module.exports = __webpack_public_path__ + "media/assets/images/blog/san_marco_which_color-small-4c807bb98a7f311b01ac5ea5fa6e5dab.png";